import { iconButtonClasses } from "@mui/material";
import styled from "styled-components";

export const BaseIconModal = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	background-color: ${({ theme }) => theme.grayLight};
	z-index: 10;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.pantoneBlack};
	}
`;

export const AreaIconCloseModal = styled(BaseIconModal)`
	position: absolute;
	top: 16px;
	right: 16px;

	&&& {
		& .${iconButtonClasses.root} {
			width: 100%;
			height: 100%;
			padding: 0;
		}
		& .${iconButtonClasses.disabled} {
			opacity: 0.2;
			cursor: not-allowed;
		}
	}
`;
